import { z } from 'zod'

export const InventoryValuationMethodSchema = z.enum(['FIFO', 'WeightedAverage'])
export type InventoryValuationMethod = z.infer<typeof InventoryValuationMethodSchema>

export const InventoryItemSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  code: z.string(),
  name: z.string(),
  valuationMethod: InventoryValuationMethodSchema,
  uom: z.string(),
  currentStock: z.number().default(0),
  averageUnitCost: z.number().default(0),
  assetAccountCode: z.string(),
  cogsAccountCode: z.string(),
  reorderPoint: z.number().optional(),
})
export type InventoryItem = z.infer<typeof InventoryItemSchema>

export const InventoryCostLayerSchema = z.object({
  id: z.string(),
  itemId: z.string(),
  purchaseDate: z.number(),
  quantityRemaining: z.number(),
  unitCost: z.number(),
  poNumber: z.string().optional(),
})
export type InventoryCostLayer = z.infer<typeof InventoryCostLayerSchema>

export const InventoryTransactionSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  itemId: z.string(),
  transactionType: z.enum(['RECEIPT', 'ISSUE', 'ADJUSTMENT']),
  quantity: z.number(),
  unitCost: z.number(),
  totalAmount: z.number(),
  referenceNumber: z.string().optional(),
  timestamp: z.number(),
})
export type InventoryTransaction = z.infer<typeof InventoryTransactionSchema>

export const CogsCalculationResultSchema = z.object({
  cogsAmount: z.number(),
  unitCostAvg: z.number(),
  layersConsumed: z.array(z.object({
    layerId: z.string(),
    qty: z.number(),
    unitCost: z.number(),
  })),
  remainingStock: z.number(),
})
export type CogsCalculationResult = z.infer<typeof CogsCalculationResultSchema>
